import { useMediaQuery, useTheme } from "@material-ui/core";
export const useIsPhoneView = () => {
    const theme = useTheme();
    const isPhoneView = useMediaQuery(theme.breakpoints.down('xs'));
    return isPhoneView;
};
//# sourceMappingURL=useIsPhoneView.js.map